export default "/_next/static/chunks/10.mp4.7aa1483903c2db4a0f1a9a92620da487.chunk";